import Authorization from "components/routing/Authorization"
import {Role} from "util/role"
import {Outlet, Route, Routes} from "react-router-dom"
import {Layout} from "antd"
import Shared from "components/shared/Shared"
import FinalizeDecision from "components/shared/FinalizeDecision"

const {Content} = Layout

export default function SharedPage() {
	return (
		<Authorization roles={Role.Doctor}>
			<Routes>
				<Route path=":sessionId/" element={<Site/>}>
					<Route path="" element={<Shared/>}/>
					<Route path="finalize" element={<FinalizeDecision/>}/>
				</Route>
			</Routes>
		</Authorization>
	)
}

function Site() {
	return (
		<Layout className="site_container">
			<Content>
				<Outlet/>
			</Content>
		</Layout>
	)
}
